import { H3CoreErrorTypes } from './types';

export function getErrorMessage(
  errorKey: H3CoreErrorTypes,
  t: (arg0: string, ...args: string[]) => string,
) {
  switch (errorKey) {
    case 'SSLCertificateError':
      return t('integrations.h3core.errors.sslcertificateerror');
    case 'NoConnection':
      return t('integrations.h3core.errors.noconnection');
    case 'UnknownError':
      return t('integrations.h3core.errors.unknownerror');
    case 'AuthFailed':
      return t('integrations.h3core.errors.authfailed');
    case 'NotNullValue':
      return t('integrations.h3core.errors.notnullvalue');
    case 'EmptyResponse':
      return t('integrations.h3core.errors.emptyresponse');
    case 'NotFound':
      return t('integrations.h3core.errors.notfound');
    default:
      return errorKey;
  }
}
